import { render, staticRenderFns } from "./blocksDetail.vue?vue&type=template&id=7834dd2e&scoped=true&"
import script from "./blocksDetail.vue?vue&type=script&lang=js&"
export * from "./blocksDetail.vue?vue&type=script&lang=js&"
import style0 from "./blocksDetail.vue?vue&type=style&index=0&id=7834dd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7834dd2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7834dd2e')) {
      api.createRecord('7834dd2e', component.options)
    } else {
      api.reload('7834dd2e', component.options)
    }
    module.hot.accept("./blocksDetail.vue?vue&type=template&id=7834dd2e&scoped=true&", function () {
      api.rerender('7834dd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/blocksDetail.vue"
export default component.exports